export const DEFAULT_BUSINESS_UNIT_ID = 0;